<template>
    <NDrawerContent>
        <h6>Terms of Use</h6>
        <p>This data on this page is subject to copyright. All rights reserved. No part of this document may be copied,
            reproduced, displayed, stored in a retrieval system or transmitted in any form or by any means whether
            electronically, through photocopying, recording or otherwise, without the prior written permission of
            Project
            Blue.</p>

        <p>The use of Project Blue products and services is restricted to the customer and any authorised licenced users
            (as applicable) on behalf of the customer, as agreed in writing by Project Blue. The customer shall ensure
            and
            shall procure that any authorised licensed users (as applicable) ensure, that Project Blue products and
            services
            are kept confidential and secure.</p>

        <p>Project Blue accepts no liability for any loss incurred by any person acting or refraining from acting as a
            result of this document. For full terms and conditions of use for Project Blue products and services, please
            refer to our website, <a href="https://www.projectblue.com/terms-of-use"
                target="_blank">www.projectblue.com/terms-of-use</a>, or alternatively, you may request them from us via
            email.</p>

        <h6>Data Sources & Methodology</h6>
        <p>Critical raw materials are a complex and opaque industry. At Project Blue we set the standard for
            trustworthy,
            transparent, and high-quality market intelligence that empowers our clients to make informed decisions with
            confidence.</p>

        <p>Our research is led by experts in their fields, with decades of combined experience in mineral economics.
            Primary research is the cornerstone of our research offering, providing us with unparalleled, firsthand
            insights
            that drive the depth, accuracy, and reliability of our analysis. Our research products all draw upon a
            series of
            proprietary in-house demand models which are updated monthly. Project Blue subscribes to a wide range of
            secondary data sources to support its research. Our supply models are built bottom-up, ensuring a granular
            and
            accurate picture of market dynamics. Project Blue uses publicly released data, as well as leveraging our
            network
            of industry contacts to estimate commodity production, demand and development costs.</p>

        <p>Our historical price data shows average monthly and annual data from subscriptions (including Shanghai Metal
            Markets, Asian Metals, Metals Hub, Global Trade Tracker, and others), which provide the baseline for Project
            Blue's independent price forecasts. Our price forecasts are based on expert judgement over four horizons:
        </p>

        <ul>
            <li>
                <p><strong>Short-term (3 months)</strong> – driven by sentiment, seasonality, and immediate
                    macroeconomic,
                    geopolitical, and fundamental factors.</p>
            </li>
            <li>
                <p><strong>Near-term (2 years)</strong> – incorporates sentiment, structural supply-demand shifts,
                    macroeconomic shocks, and seasonality. Prices are forecast quarterly in real terms.</p>
            </li>
            <li>
                <p><strong>Medium-term (5 years)</strong> – uses near-term methods for the first two years, then
                    supply-demand
                    models, cost analysis, and market fundamentals. Prices are forecast annually and updated quarterly.
                </p>
            </li>
            <li>
                <p><strong>Long-term (10 years)</strong> – focuses on supply-demand trends and investment needs. Prices
                    are
                    fixed to a base case in real-currency terms for years 6–10.</p>
            </li>
        </ul>

        <p>Project Blue retains the right to change and update both historical and forecast data based on our most
            up-to-date analysis – promising ongoing improvements to commodity analysis and forecasts.</p>

        <h6>Forward Looking Statement</h6>
        <p>This document may contain forward-looking statements that are subject to risks and uncertainties. All
            statements that are not historical facts contained within are forward-looking statements. In some cases, you
            can
            identify forward-looking statements by terminology such as “can,” “might,” “believe,” “may,” “estimate,”
            “continue,” “anticipate,” “intend,” “should,” “plan,” “could,” “expect,” “predict,” “potential,” or other
            similar expressions.</p>

        <p>Forward-looking statements are based on information and assumptions that Project Blue had when those
            statements
            are made or its good faith belief as of that time with respect to future events. Forward-looking statements
            are
            subject to risks and uncertainties that could cause actual performance or results to differ materially from
            those in or suggested by the forward-looking statements.</p>

        <p>Except as required by law, Project Blue undertakes no obligation to update publicly any forward-looking
            statements after the date of this publication release, or to conform these statements to actual results or
            changes. While consideration has been taken in preparing the information published in this report, the
            content
            is provided without any guarantees, conditions, or warranties as to its accuracy, completeness, or
            reliability.
        </p>

        <p>We accept no liability to third parties, howsoever arising. Although reasonable care and diligence has been
            used in the preparation of this report, we do not guarantee the accuracy of any data, assumptions, forecasts
            or
            other forward-looking statements.</p>

    </NDrawerContent>

</template>
<script setup>
import { NDrawerContent } from "naive-ui";
</script>